import React from 'react';
import { Button, List } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import StrongTag from '../StrongTag/StrongTag';
import './styles.less';

const LinksList = ( { title, items, showFormat, handleClickCallback } ) => {
    return (
        <>
            { ( items && items.length > 0 ) &&
                <List
                    className="links-list"
                    size="small"
                    header={ <strong>{ title }</strong> }
                    dataSource={ items }
                    locale={ { emptyText: 'No data' } }
                    renderItem={ i => 
                        <List.Item
                            key={ i.id }
                            extra= {
                                <Button 
                                    type="link" 
                                    icon={ <EditOutlined /> } 
                                    onClick = { () => handleClickCallback( i.id ) }
                                />
                            }
                        > 
                            { showFormat ? (
                                <div>
                                    <StrongTag 
                                        className="uppercase"
                                        color="blue"
                                        strontText={ i.format }
                                    />
                                    { i.name }
                                </div> ) : i.name
                            }
                        </List.Item>
                    }
                />
            }
        </>
    );
};

export default LinksList;
